import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">平台更新与影视快讯，不错过每一个变化</p>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-3 bottom-3 w-px bg-background-300/60"></div>

            <div className="space-y-6">
              {updatesData.map((item) => (
                <div key={item.id} className="relative pl-10 md:pl-14">
                  <div className="absolute left-2.5 md:left-4.5 top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>

                  <div className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70">
                    <span className="text-xs text-primary-600 font-medium">{item.date}</span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 mt-1 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}